import React, { useState } from 'react'
import './Navbar.css';
import Button from '../Button/Button';
import { useEffect } from 'react';
import SectionIds from '../../Helper/SectionId';
import Dropdown from './Dropdown';

import { motion, MotionConfig } from 'framer-motion';
import { Link } from 'react-router-dom';
import ScrollToAnchor from './ScrollToAnchor';
import scrollIntoView from '../../Helper/ScrollIntoView';
import AssetImage from '../../Helper/AssetImage';
import AssetImages from '../../Helper/AssetImages';

export default function Navbar(props) {
  const [changeNavbar, setChangeNavbar] = useState(false);
  const [hamburgerActive, setHamburgerActive] = useState(false);

  const handleScroll = () => {
    const scrollY = window.scrollY;
    // Set a threshold value to determine when to change navbar color
    const threshold = 100;

    if (scrollY > threshold && !changeNavbar) {
      setChangeNavbar(true);
    } else if (scrollY <= threshold && changeNavbar) {
      setChangeNavbar(false);
    }
  };


  useEffect(() => {
    const handleResize = () => {
      // setWindowWidth(window.innerWidth);
      // if (window.innerWidth < 800) {
      setHamburgerActive(false); // Close menu if window width is less than 800px
      // }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [changeNavbar]);


  return (
    <header className={changeNavbar || props.isPrimary ? 'navbar primary' : 'navbar'} >
      <div className="navbar-content">
        <div className='nav-logo-banner'>
          <AssetImage className='nav-logo' assetImage={AssetImages.imageWolfInvestmentLogo} />
        </div>
        <div className='placeholder'></div>

        <AnimatedHamburgerButton
          isActive={hamburgerActive}
          onClick={() => {
            setHamburgerActive((prev) => !prev)
          }}
        />

        <nav>
          {
            props.navitems.map((element, index) => {
              return <NavItem key={index} route={element.route} itemName={element.item} />
            })
          }


          <ScrollToAnchor></ScrollToAnchor>

        </nav>
        <Button
          className='navbar-cta'
          name="Contact Me"
          onClick={() => scrollIntoView(SectionIds.sectionContactMe)} />
      </div>

      <Dropdown
        isActive={hamburgerActive}
        navitems={props.dropdownNavitems}
        onItemClick={() => {
          setHamburgerActive(false)
        }}>

      </Dropdown>
    </header>
  )
}


function NavItem(props) {
  return (
    <Link key={props.key} to={props.route}>
      <a className='navitem'>
        {props.itemName}
      </a>
    </Link>

  )
}

const AnimatedHamburgerButton = (props) => {

  return (
    <MotionConfig
      transition={{
        duration: 0.5,
        ease: "easeInOut",
      }}
    >
      <motion.button
        initial={false}
        animate={props.isActive ? "open" : "closed"}
        onClick={props.onClick}
        isActive={props.isActive}
        className="hamburger-btn "
      >
        <motion.span
          variants={VARIANTS.top}

          style={{ y: "-50%", left: "50%", x: "-50%", top: "35%" }}
        />
        <motion.span
          variants={VARIANTS.middle}

          style={{ left: "50%", x: "-50%", top: "50%", y: "-50%" }}
        />
        <motion.span
          variants={VARIANTS.bottom}

          style={{
            x: "-88%",
            y: "50%",
            bottom: "35%",
            left: "calc(50% + 10px)",
          }}
        />
      </motion.button>
    </MotionConfig>
  );
};

const VARIANTS = {
  top: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      top: ["35%", "50%", "50%"],
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      top: ["50%", "50%", "35%"],
    },
  },
  middle: {
    open: {
      rotate: ["0deg", "0deg", "-45deg"],
    },
    closed: {
      rotate: ["-45deg", "0deg", "0deg"],
    },
  },
  bottom: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      bottom: ["35%", "50%", "50%"],
      left: "69%",
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      bottom: ["50%", "50%", "35%"],
      left: "calc(50% + 10px)",
    },
  },
};






